export default "__VITE_ASSET__cdaebae6__"